import PrimaryButton         from './primary_button';
import React                 from 'react';
import ResourceNotFoundImage from '../assets/images/resource-not-found.svg';



export default function NotFoundPage({ title = 'Oops, page not found.' }) {
  return (
    <div className="resource-error">
      <ResourceNotFoundImage className="resource-not-found__image"/>
      <h2>{title}</h2>
      <div className="resource-error__cta">
        <PrimaryButton label="Restart" onClick={toRootPage}/>
      </div>
    </div>
  );
}


function toRootPage() {
  // This is not quite Ctrl + Alt + Del because it doesn't reset the Redux
  // store, more like Cmd + R.  So ignore the button label and focus on the
  // function name.
  window.location.href = window.location.href.split('#')[0];
}
